/* eslint-disable react/jsx-no-bind */
import { useContext, useEffect, useState, useRef } from 'react'
import { IMAGES } from 'configs/configs.js'
import styled from 'styled-components'
import { Icon } from 'assets/index'
import { InfoCard, NewModal, ResumeSelectCard } from 'components/index'
import { Theme } from 'styles/Themes'
import { GeneralContext, UserContext } from 'context'
import { hasAccess } from 'helper/utils'
import { IObject } from 'interfaces'
import { useFetch, useStorage } from 'hooks'
import trashWhite from './trashWhite.svg'
import DeleteProposta from '../DeleteProposta'

interface IProps {
  title?: string
  subtitle?: string
  status?: string
  user?: IObject
  type?: string
  statusOptions?: any
  // gestor?: any
  gestorId?: any
  tokenGestorId?: any
  contractId?: string
  trash?: boolean
  backModal?: boolean
}

const Trash = styled.img`
  margin-left: 20px;
  height: 24px;
  width: 24px;
  cursor: pointer;
`

export default function (props: IProps) {
  const {
    title,
    status,
    subtitle,
    user,
    type,
    statusOptions,
    gestorId,
    tokenGestorId,
    contractId,
    trash,
    backModal,
  } = props
  const [specialist, setSpecialist] = useState<IObject>({})
  const { selectedId } = useContext(UserContext)
  const general = useContext(GeneralContext)
  const [localModal, setLocalModal] = useState(false)
  const api = useFetch()
  const [userPer] = useStorage('User')
  // const specialistList = general.gestor.get()
  const [colaboradores] = useStorage('Colaboradores')

  useEffect(() => {
    setSpecialist(colaboradores[0])
  }, [])

  /**
   * Function para atualizar o especialista do cliente
   * @param {string} document - CPF/CNPJ do cliente
   * @param {string} specialistId - Id do novo especialista
   */
  function onChangeSpecialist(spe: IObject) {
    api
      .fetch('post', { gestorId: spe.id }, `/gestor/account/${user?.document}`)
      .catch(console.error)
    setSpecialist(spe)
  }

  function changeStatus(e: any) {
    const statusE = String(e.value)
    api
      .fetch(
        'put',
        { status: statusE },
        `/gestor/kanban/comercial/${selectedId.current}`
      )
      .then((r: IObject) => {
        console.log(r)
      })
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          width: '100%',
          justifyContent: 'flex-start',
        }}
      >
        <h1 style={{ width: 'auto' }} className="detalhes-captacao-title">
          {title}
        </h1>
        {trash && hasAccess('wallet-remove-captation') && (
          <Trash
            id={'wallet-remove-captation'}
            data-tip
            data-for={`trashcan`}
            alt={'trahs-icon'}
            src={Icon('trash.svg')}
            onClick={() => {
              setLocalModal(true)
            }}
          />
        )}
      </div>
      <div className="status-card-captacao">
        <img
          className="status-card-captacao-img"
          src={Icon('alert_triangle.svg')}
          alt="status icon"
        />
        <span>{status}</span>
      </div>
      <div className="detalhes-container123">
        <h4 className="detalhes-captacao-subtitle">{`${subtitle} ${type}`}</h4>
      </div>
      <div className="status-card-container-cards">
        <InfoCard icon={Icon('trophy.svg')} value={type || ''}>
          Modalidade da captação
        </InfoCard>
        <InfoCard icon={Icon('trophy.svg')} value={user?.name || ''}>
          Cliente
        </InfoCard>
        {/* {general.user.isSpecialist() ? (
          <ResumeSelectCard
            name={specialist?.name}
            specialist
            icon={`${IMAGES.URL}/icons/imagem.svg`} // specialist?.profilePic
            options={specialistList.map((g: any) => {
              return {
                ...g,
                value: g,
                label: g.name,
                image: `${IMAGES.URL}/icons/imagem.svg`,
              }
            })}
            text=""
            handleChange={(item: any) => onChangeSpecialist(item.value)}
          >
            Especialista
          </ResumeSelectCard>
        ) : (
          <InfoCard icon={Icon('imagem.svg')} value={'Fernando Lemos'}>
            Especialista
          </InfoCard>
        )} */}
        <InfoCard
          icon={`${IMAGES.URL}/images/${
            colaboradores.find((item: any) => item.id === gestorId)?.profilePic
          }`}
          value={colaboradores.find((item: any) => item.id === gestorId)?.name}
          pic
          width={250}
        >
          Especialista
        </InfoCard>
        {tokenGestorId && (
          <InfoCard
            icon={`${IMAGES.URL}/images/${
              colaboradores.find((item: any) => item.id === tokenGestorId)
                ?.profilePic
            }`}
            value={
              colaboradores.find((item: any) => item.id === tokenGestorId)?.name
            }
            pic
            width={250}
          >
            Responsável pela capitação
          </InfoCard>
        )}
        <InfoCard icon={Icon('trophy.svg')} value={status || ''}>
          Status
        </InfoCard>
      </div>
      {/* <ResumeSelectCard
        name={status}
        options={statusOptions}
        text=""
        handleChange={changeStatus}
      >
        Status
      </ResumeSelectCard> */}
      <NewModal
        showModal={localModal}
        height="45%"
        width="60%"
        setShowModal={setLocalModal}
        noCloseButton
        padding={'30px'}
      >
        <DeleteProposta
          backModal={backModal}
          onCancel={() => setLocalModal(false)}
          id={contractId || ''}
        />
      </NewModal>
    </>
  )
}
